import * as React from "react";

const MOBILE_BREAKPOINT = 768;
const SHORT_VIEWPORT_BREAKPOINT = 600;

/**
 * Matches the `compact` Tailwind screen: narrow OR short.
 * A phone in landscape is wider than 768px but only ~400px tall, so width alone misses it.
 */
const COMPACT_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px), (max-height: ${SHORT_VIEWPORT_BREAKPOINT - 1}px)`;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(COMPACT_MEDIA_QUERY);
    const onChange = () => {
      setIsMobile(mql.matches);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
